import Vue from 'vue';
import Vuex from 'vuex';
import Notification from 'element-ui/lib/notification';
Vue.use(Vuex);
import {downloadXML} from '@/tools/utils'
//  需要维护的状态
const state = {
  user: {},
  org:{},
  dict: {},
  dhsDict: {},
  requestingDhsDictAry: [],
  permissions: [],
  permList: {},
  roleList: {},
  attachmentDialog: {attachmentId: 0, open: false, attachmentList: [], objectId: '', objectType: ''},
  windowSize: {width: 1000, height: 500},
  form: {},
  bodyHeight: 0,
  domainInfo: {},
  orgRelationLevel: [],
  requestingDictAry: [],
  bottomLoading: false,
  menuParentIds: [], // 所有非叶子节点菜单
  print: {
    isPrinting: false,
    text: '正在下载'
  },
  isShowGoodsList: false,
  physicDetailType: [
    {key: '1', label: '麻醉药品原料药'},
    {key: '2', label: '第一类精神药品原料药'},
    {key: '3', label: '第二类精神药品原料药'},
    {key: '4', label: '麻醉药品'},
    {key: '5', label: '第一类精神药品'},
    {key: '6', label: '第二类精神药品'},
    {key: '7', label: '中药注射剂'},
    {key: '8', label: '疫苗'},
    {key: '9', label: '血液制品'},
    {key: '10', label: '国家基本药品目录入网药品'},
    {key: '11', label: '非基本药物'},
    {key: '12', label: '各省增补基本药物'},
    {key: '13', label: '特殊药品复方制剂'}
  ],
  orgRelationType: [
    {key: '1', label: '境内药品生产企业'},
    {key: '2', label: '境外药品生产企业'},
    {key: '3', label: '境内医疗器械生产企业'},
    {key: '4', label: '境外医疗器械生产企业'},
    {key: '5', label: '药品经营企业'},
    {key: '6', label: '医疗器械经营企业'},
    {key: '7', label: '进口代理企业'},
    {key: '8', label: '疾病预防控制机构'},
    {key: '9', label: '配送单位'},
    {key: '10', label: '疫苗接种单位'},
    {key: '11', label: '医疗机构'},
    {key: '12', label: '其他'}
  ],
  goodsTypeList: [
    {key: '1', label: '疫苗（国产）'},
    {key: '2', label: '疫苗（进口）'},
    {key: '3', label: '一般药品（国产）'},
    {key: '4', label: '一般药品（进口）'},
    {key: '5', label: '特殊药品（国产）'},
    {key: '6', label: '特殊药品（进口）'},
    {key: '7', label: '国产医疗器械'},
    {key: '8', label: '进口医疗器械'},
    {key: '9', label: '其他'}
  ],
  attachmentTypeList: [
    {
      type: 'domesticDrugRegisterPetitionAttachmentList',
      name: '药品注册批件',
      attachmentList: [],
      attachmentIdList: [],
      objectType: 'domesticDrugRegisterPetition',
      showType: [1, 3, 5]
    },
    {
      type: 'domesticSpecificationAttachmentList',
      name: '说明书',
      attachmentList: [],
      attachmentIdList: [],
      objectType: 'domesticSpecification',
      showType: [1, 2, 3, 4, 5, 6]
    },
    {
      type: 'importDrugRegisterAttachmentList',
      name: '进口药品注册证',
      attachmentList: [],
      attachmentIdList: [],
      objectType: 'importDrugRegister',
      showType: [2, 4, 6]
    },
    {
      type: 'medicalInstrumentRegisterAttachmentList',
      name: '医疗器械注册证/医疗器械备案凭证',
      attachmentList: [],
      attachmentIdList: [],
      objectType: 'medicalInstrumentRegister',
      showType: [7, 8]
    }
  ],
  licenceTypeList: [
    {type: 'drugProductionCert', name: '药品生产许可证', children: [], showType: [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]},
    {type: 'drugBusinessCert', name: '药品营业许可证', children: [], showType: [0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0]},
    {type: 'gspCert', name: 'GSP证书', children: [], showType: [0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0]},
    {type: 'gmpCert', name: 'GMP证书', children: [], showType: [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]},
    {type: 'businessCert', name: '营业执照', children: [], showType: [1, 0, 3, 0, 5, 6, 7, 0, 9, 0, 0, 0]},
    {
      type: 'medicalInstrumentProdCert',
      name: '医疗器械生产许可证/备案凭证',
      children: [],
      showType: [0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    {
      type: 'medicalInstrumentBusCert',
      name: '医疗器械经营许可证/备案凭证',
      children: [],
      showType: [0, 0, 0, 0, 0, 6, 0, 0, 0, 0, 0, 0]
    },
    {type: 'medicalOrgPracticeCert', name: '医疗机构执业许可证', children: [], showType: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 11, 0]},
    {type: 'orgProdLegalPersonCert', name: '事业单位法人证书', children: [], showType: [0, 0, 0, 0, 0, 0, 0, 8, 0, 0, 0, 0]},
    {type: 'roadTransportCert', name: '道路运输许可证', children: [], showType: [0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0]}
  ],
  licenceTypeFormItem: {
    licenceType: '',
    licenceNumber: '',
    validStartTime: '',
    validEndTime: '',
    photos: [],
    attachmentIdList: []
  },
  threeValueList: [
    {value: null, label: '待完善'},
    {value: true, label: '是'},
    {value: false, label: '否'}
  ],
  xmlBtnList: {
    0: {
      label: '导出境内疫苗生产企业基本信息数据子集',
      perm: 'export-data-type-xml-1011',
      click(id) {
        Vue.prototype.$http(`/bsp-xtpt/org/${id}/xtpt/maindata/1011`).then(res => {
          downloadXML(res.data.path, '境内疫苗生产企业基本信息数据子集');
        }).catch((e) => {
          Notification.error({
            duration: 2000,
            message: e.response && e.response.data && e.response.data.msg || '导出失败'
          });
        });
      }
    },
    1: {
      label: '导出进口疫苗生产企业基本信息数据子集',
      perm: 'export-data-type-xml-1012',
      click(id) {
        Vue.prototype.$http(`/bsp-xtpt/org/${id}/xtpt/maindata/1012`).then(res => {
          downloadXML(res.data.path, '进口疫苗生产企业基本信息数据子集');
        }).catch((e) => {
          Notification.error({
            duration: 2000,
            message: e.response && e.response.data && e.response.data.msg || '导出失败'
          });
        });
      }
    },
    2: {
      label: '导出进口疫苗代理企业基本信息数据子集',
      perm: 'export-data-type-xml-1013',
      click(id) {
        Vue.prototype.$http(`/bsp-xtpt/org/${id}/xtpt/maindata/1013`).then(res => {
          downloadXML(res.data.path, '进口疫苗代理企业基本信息数据子集');
        }).catch((e) => {
          Notification.error({
            duration: 2000,
            message: e.response && e.response.data && e.response.data.msg || '导出失败'
          });
        });
      }
    },
    3: {
      label: '导出药品生产许可证基本信息数据子集',
      perm: 'export-data-type-xml-1014',
      click(id) {
        Vue.prototype.$http(`/bsp-xtpt/goods/${id}/xtpt/maindata/1014`).then(res => {
          downloadXML(res.data.path, '药品生产许可证基本信息数据子集');
        }).catch((e) => {
          Notification.error({
            duration: 2000,
            message: e.response && e.response.data && e.response.data.msg || '导出失败'
          });
        });
      }
    },
    4: {
      label: '导出药品经营许可证基本信息数据子集',
      perm: 'export-data-type-xml-1015',
      click(id) {
        Vue.prototype.$http(`/bsp-xtpt/goods/${id}/xtpt/maindata/1015`).then(res => {
          downloadXML(res.data.path, '药品经营许可证基本信息数据子集');
        }).catch((e) => {
          Notification.error({
            duration: 2000,
            message: e.response && e.response.data && e.response.data.msg || '导出失败'
          });
        });
      }
    },
    5: {
      label: '导出国产疫苗基本信息数据子集',
      perm: 'export-data-type-xml-1019',
      click(id) {
        Vue.prototype.$http(`/bsp-xtpt/goods/${id}/xtpt/maindata/1019`).then(res => {
          downloadXML(res.data.path, '国产疫苗基本信息数据子集');
        }).catch((e) => {
          Notification.error({
            duration: 2000,
            message: e.response && e.response.data && e.response.data.msg || '导出失败'
          });
        });
      }
    },
    6: {
      label: '导出进口疫苗基本信息数据子集',
      perm: 'export-data-type-xml-1020',
      click(id) {
        Vue.prototype.$http(`/bsp-xtpt/goods/${id}/xtpt/maindata/1020`).then(res => {
          downloadXML(res.data.path, '进口疫苗基本信息数据子集');
        }).catch((e) => {
          Notification.error({
            duration: 2000,
            message: e.response && e.response.data && e.response.data.msg || '导出失败'
          });
        });
      }
    },
    7: {
      label: '导出疾病预防控制机构基本信息数据子集',
      perm: 'export-data-type-xml-1016',
      click(id) {
        Vue.prototype.$http(`/bsp-xtpt/org/${id}/xtpt/maindata/1016`).then(res => {
          downloadXML(res.data.path, '疾病预防控制机构基本信息数据子集');
        }).catch((e) => {
          Notification.error({
            duration: 2000,
            message: e.response && e.response.data && e.response.data.msg || '导出失败'
          });
        });
      }
    },
    8: {
      label: '导出接种单位基本信息数据子集',
      perm: 'export-data-type-xml-1018',
      click(id) {
        Vue.prototype.$http(`/bsp-xtpt/org/${id}/xtpt/maindata/1018`).then(res => {
          downloadXML(res.data.path, '接种单位基本信息数据子集');
        }).catch((e) => {
          Notification.error({
            duration: 2000,
            message: e.response && e.response.data && e.response.data.msg || '导出失败'
          });
        });
      }
    },
    9: {
      label: '导出疫苗配送单位基本信息数据子集',
      perm: 'export-data-type-xml-1017',
      click(id) {
        Vue.prototype.$http(`/bsp-xtpt/org/${id}/xtpt/maindata/1017`).then(res => {
          downloadXML(res.data.path, '疫苗配送单位基本信息数据子集');
        }).catch((e) => {
          Notification.error({
            duration: 2000,
            message: e.response && e.response.data && e.response.data.msg || '导出失败'
          });
        });
      }
    },
    10: {
      label: '导出生产信息',
      perm: 'export-data-type-xml-2011',
      click(id) {
        Vue.prototype.$http(`bsp-xtpt/order/${id}/xtpt/appdata/2011`).then(res => {
          downloadXML(res.data.path, '生产信息');
        }).catch((e) => {
          Notification.error({
            duration: 2000,
            message: e.response && e.response.data && e.response.data.msg || '导出失败'
          });
        });
      }
    },
    11: {
      label: '导出进口信息',
      perm: 'export-data-type-xml-2012',
      click(id) {
        Vue.prototype.$http(`bsp-xtpt/order/${id}/xtpt/appdata/2012`).then(res => {
          downloadXML(res.data.path, '进口信息');
        }).catch((e) => {
          Notification.error({
            duration: 2000,
            message: e.response && e.response.data && e.response.data.msg || '导出失败'
          });
        });
      }
    },
    12: {
      label: '导出批签发信息',
      perm: 'export-data-type-xml-2014',
      click(id) {
        Vue.prototype.$http(`bsp-xtpt/batch-number/${id}/xtpt/appdata/2014`).then(res => {
          downloadXML(res.data.path, '批签发信息');
        }).catch((e) => {
          Notification.error({
            duration: 2000,
            message: e.response && e.response.data && e.response.data.msg || '导出失败'
          });
        });
      }
    },
    13: {
      label: '导出发货单信息',
      perm: 'export-data-type-xml-2015',
      click(id) {
        Vue.prototype.$http(`bsp-xtpt/order/${id}/xtpt/appdata/2015`).then(res => {
          downloadXML(res.data.path, '发货单信息');
        }).catch((e) => {
          Notification.error({
            duration: 2000,
            message: e.response && e.response.data && e.response.data.msg || '导出失败'
          });
        });
      }
    },
    14: {
      label: '导出收货单信息',
      perm: 'export-data-type-xml-2016',
      click(id) {
        Vue.prototype.$http(`bsp-xtpt/order/${id}/xtpt/appdata/2016`).then(res => {
          downloadXML(res.data.path, '收货单信息');
        }).catch((e) => {
          Notification.error({
            duration: 2000,
            message: e.response && e.response.data && e.response.data.msg || '导出失败'
          });
        });
      }
    },
    15: {
      label: '导出使用信息',
      perm: 'export-data-type-xml-2017',
      click(id) {
        Vue.prototype.$http(`bsp-xtpt/use-info/${id}/xtpt/appdata/2017`).then(res => {
          downloadXML(res.data.path, '使用信息');
        }).catch((e) => {
          Notification.error({
            duration: 2000,
            message: e.response && e.response.data && e.response.data.msg || '导出失败'
          });
        });
      }
    },
    16: {
      label: '导出库存信息',
      perm: 'export-data-type-xml-2019',
      click(id) {
        Vue.prototype.$http(`bsp-xtpt/stock/${id}/xtpt/appdata/2019`).then(res => {
          downloadXML(res.data.path, '库存信息');
        }).catch((e) => {
          Notification.error({
            duration: 2000,
            message: e.response && e.response.data && e.response.data.msg || '导出失败'
          });
        });
      }
    },
  },
  colorList: [
    'pink',
    'lightBlue',
    'red',
    'green',
    'yellow',
    'purple'
  ]
};

const mutations = {
  initDhsDict(state, data) {
    state.dhsDict = data;
  },
  initRequestingDhsDictAry(state, data) {
    state.requestingDhsDictAry = data;
  },
  initUser(state, data) {
    try {
      if (data && data.userId) {
        window.localStorage.setItem('user', JSON.stringify(data));
        state.user = data;
      }
    } catch (e) {

    }
  },
  initOrg(state, data) {
    try {
      if (data && data.id) {
        window.localStorage.setItem('org', JSON.stringify(data));
        state.org = data;
      }
    } catch (e) {

    }
  },
  initDict(state, data) {
    state.dict = data;
  },
  initPermissions(state, data) {
    state.permissions = data;
  },
  initPermList(state, data) {
    state.permList = data;
  },
  changeAttachment(state, data) {
    let currentId;
    if (typeof data === 'object') {
      currentId = data.currentId;
      state.attachmentDialog.attachmentList = data.attachmentList;
    } else {
      currentId = data;
      state.attachmentDialog.attachmentList = [];
    }
    if (state.attachmentDialog.attachmentId === currentId) {
      state.attachmentDialog.open = true;
    } else {
      state.attachmentDialog.attachmentId = currentId;
    }
  },
  openAttachmentDialog(state) {
    state.attachmentDialog.open = true;
  },
  closeAttachmentDialog(state) {
    state.attachmentDialog.open = false;
  },
  setBodyHeight(state, data) {
    state.bodyHeight = data.height;
    state.windowSize = data.window;
  },
  initDomainInfo(state, data) {
    state.domainInfo = data;
    let title = document.getElementById('codesTitle');
    if (data.id) {
      title.innerHTML = data.name ? data.name : '全溯';
    } else {
      title.innerHTML = '全溯';
    }
  },
  initPrint(state, data) {
    data.text = data.text || '正在下载';
    state.print = data;
  },
  inItOrgRelationLevel(state, data) {
    state.orgRelationLevel = data;
  },
  initRequestingDictAry(state, data) {
    state.requestingDictAry = data;
  },
  initMenuParentIds(state, data) {
    state.menuParentIds = data;
  },
  initBottomLoading(state, data) {
    state.bottomLoading = data;
  },
  initIsShowGoodsList(state, data) {
    state.isShowGoodsList = data;
  }
};

export default new Vuex.Store({
  state,
  mutations
});

